<template lang="html">
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-form-item label="是否开票" prop="isBilling">
      <el-radio-group v-model="ruleForm.isBilling">
        <el-radio label="1">是</el-radio>
        <el-radio label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="付款类型" prop="paymentMethod">
      <el-radio-group v-model="ruleForm.paymentMethod">
        <el-radio label="0">回付</el-radio>
        <el-radio label="1">到付</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="需要回单" prop="isNeedReceipt">
      <el-radio-group v-model="ruleForm.isNeedReceipt">
        <el-radio label="1">是</el-radio>
        <el-radio label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        isBilling: "1",
        paymentMethod: "0",
        isNeedReceipt: "1"
      },
      rules: {
        isBilling: [
          { required: true, message: "请选择", trigger: ["blur", "change"] }
        ],
        paymentMethod: [
          { required: true, message: "请选择", trigger: ["blur", "change"] }
        ],
        isNeedReceipt: [
          { required: true, message: "请选择", trigger: ["blur", "change"] }
        ]
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    async formValidate() {
      try {
        let result = await this.$refs.ruleForm.validate();
        return Promise.resolve(result);
      } catch (e) {
        return Promise.reject(new Error(e));
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/costInfoWrapper/index.vue